import { AccessRequestsScopeModel, accessStatusesClosed } from '@apono/client-app-sdk';

import { NoResults } from '@common/ui/NoResults';
import { Loader } from '@common/ui/Loader';
import useRequestsTable from '@common/hooks/use-requests-table';

import ClosedRequestsTable from '../organisms/ClosedRequestsTable';

export default function ClosedRequestsPage() {
  const {
    isFetched,
    isLoading: isFetching,
    pageData,
    selectedRequestId,
    handleRequestClick,
    handleOnPageChange,
  } = useRequestsTable({
    statuses: accessStatusesClosed,
    scope: AccessRequestsScopeModel.MyRequests,
  });

  if (!isFetched) {
    return <Loader />;
  }

  if (!pageData || pageData.data.length === 0) {
    return <NoResults>No requests found</NoResults>;
  }

  return (
    <ClosedRequestsTable {...{ isFetching, pageData, selectedRequestId, handleRequestClick, handleOnPageChange }} />
  );
}
